import { BarChart3, Cpu, HardDrive, Sparkles } from 'lucide-react';

import { PlatformDownloads } from '@/components/platform-downloads';
import { Reveal } from '@/components/reveal';
import { useLocale } from '@/i18n/locale-context';

export function CapabilitiesSection() {
  const { t } = useLocale();
  const icons = [BarChart3, Cpu, HardDrive];

  return (
    <section id="capabilities" className="scroll-mt-24 px-6 py-20 sm:px-10 sm:py-28">
      <div className="mx-auto w-full max-w-6xl">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="section-eyebrow">{t.capabilities.eyebrow}</p>
          <h2 className="mt-4 font-display text-3xl leading-[1.12] tracking-tight sm:text-4xl">{t.capabilities.title}</h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-7 text-muted-foreground">
            {t.capabilities.description}
          </p>
        </Reveal>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {t.capabilities.items.map((item, index) => {
            const Icon = icons[index] ?? Sparkles;

            return (
              <Reveal key={item.eyebrow} delay={index * 0.08}>
                <article className="group h-full rounded-xl border border-border/70 bg-card/40 p-6 transition-all duration-300 hover:border-primary/30 hover:bg-card/70 hover:shadow-sm">
                  <div className="flex items-center gap-2">
                    <Icon className="h-4 w-4 text-foreground/60 transition-colors duration-300 group-hover:text-primary" strokeWidth={1.5} />
                    <p className="text-[10px] font-medium uppercase tracking-[0.14em] text-muted-foreground">{item.eyebrow}</p>
                  </div>
                  <h3 className="mt-4 text-lg font-medium tracking-tight">{item.title}</h3>
                  <p className="mt-2 text-sm leading-6 text-muted-foreground">{item.description}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export function DownloadSection() {
  const { t } = useLocale();

  return (
    <section id="download" className="scroll-mt-24 px-6 pb-20 pt-10 sm:px-10 sm:pb-28">
      <Reveal className="relative mx-auto max-w-6xl overflow-hidden rounded-2xl border border-border/50 bg-card/40 px-6 py-16 text-center text-foreground sm:px-12 sm:py-20">
        <div className="relative">
          <p className="text-[11px] font-medium uppercase tracking-[0.16em] text-muted-foreground">{t.download.eyebrow}</p>
          <h2 className="mx-auto mt-4 max-w-xl font-display text-3xl leading-[1.12] tracking-tight sm:text-4xl">
            {t.download.title}
          </h2>
          <p className="mx-auto mt-4 max-w-md text-sm leading-6 text-muted-foreground">{t.download.description}</p>
          <div className="mt-10">
            <PlatformDownloads />
          </div>
        </div>
      </Reveal>
    </section>
  );
}
